$('.themes__btn-show').on('click', (e)=>{
    e.stopPropagation();
    const $height = ($('.promo').height() < ($('.themes__list').height() + 55)) ? ($('.themes__list').height() + 55) : $('.promo').height();
    if($('.themes').hasClass('themes_opened')){
        if($('.promo-block').width() == $('.promo').width()){
            $('.themes').animate({'height': '220px'}, 500, function(){
                $('.themes').removeClass('themes_opened');
            });
        }
        else{
            $('.promo-block').animate({'height': $('.promo').height()}, 500, function () {
                $('.themes').removeClass('themes_opened');
            });
        }
    }
    else{
        if($('.promo-block').width() == $('.promo').width()){
            $('.themes').animate({'height': $('.themes__list').height() + 55}, 500, function(){
                $('.themes').addClass('themes_opened');
            });
        }
        else {
            $('.promo-block').animate({'height': $height}, 500, function () {
                $('.themes').addClass('themes_opened');
            });
        }
    }
});
window.addEventListener('resize', ()=>{
    if($('.promo-block').length > 0) {
        if ($('.promo-block').width() == $('.promo').width()) {
            $('.promo-block').height('auto');
            $('.themes').height('220px').removeClass('themes_opened');
        }
        else {
            $('.themes').height('100%');
            $('.themes').removeClass('themes_opened');
        }
    }
});

$('.footer__title').on('click', ()=>{
    if($('.footer__programs:hidden').length > 0){
        $('.footer__programs').slideDown();
    }
});

if($('.article__text p').length >= 1){
    $('.article__text p').eq($('.article__text p').length-1).append('<span class="article_end"></span>');
}

// if($('.article__text').length >= 1) {
//     document.querySelectorAll('.article__text a')
//         .forEach(function(elem) {
//             elem.removeAttribute('target');
//             elem.setAttribute('target', '_blank');
//         });
// }
